import { FC, useEffect, useState } from "react";
import { Box, Typography, TextField } from "@mui/material";

import CustomModal from "../../../components/common/custom-modal/custom-modal";
import { CustomButton } from "../../../components";
import { Colors } from "../../../configs";
import { pxToRem } from "../../../util";

interface RegisterNoteModalProps {
  open: boolean;
  onClose: () => void;
  onAddReason: (reason: string) => void;
  station?: number;
}

export const RegisterNoteModal: FC<RegisterNoteModalProps> = ({
  open,
  onClose,
  onAddReason,
  station,
}) => {
  const [inputValue, setInputValue] = useState<string>("");

  const handleAddNote = () => {
    if (inputValue) {
      onAddReason(inputValue);
      onClose();
    }
  };

  useEffect(() => {
    if (!open) {
      setInputValue("");
    }
  }, [open]);

  return (
    <CustomModal
      title="Register Note"
      openModal={open}
      onClose={onClose}
      width={pxToRem(680)}
      height={pxToRem(555)}
    >
      <Box
        sx={{
          marginTop: pxToRem(36),
          display: "flex",
          flexDirection: "column",
          gap: pxToRem(16),
        }}
      >
        <Typography
          sx={{
            fontSize: pxToRem(24),
            color: Colors.MAIN_GRAY,
            textAlign: "left",
          }}
        >
          Note about this register balancing{station ? ` for Station ${station}` : ''}:
        </Typography>
        <TextField
          placeholder="Add your note here..."
          sx={{
            width: "100%",
            height: pxToRem(218),
            "& .MuiOutlinedInput-root": {
              height: pxToRem(218),
              padding: 1,
              "& fieldset": {
                borderColor: Colors.MAIN_GRAY,
              },
            },
            "& .MuiInputBase-input": {
              height: `${pxToRem(218)} !important`,
              maxHeight: `${pxToRem(218)} !important`,
              padding: `${pxToRem(12)} ${pxToRem(14)} !important`,
              fontSize: "1.428571428571429rem",
              color: Colors.MAIN_GRAY,
              overflowY: "auto !important",
              overflowX: "hidden !important", 
              resize: "none !important",
              boxSizing: "border-box !important", 
              verticalAlign: "top !important",
              textAlign: "left",
              wordWrap: "break-word", 
              whiteSpace: "pre-wrap",
            },
            "& .MuiInputBase-inputMultiline": {
              height: `${pxToRem(194)} !important`,
              maxHeight: `${pxToRem(194)} !important`,
              padding: `${pxToRem(12)} ${pxToRem(14)} !important`,
              overflowY: "auto !important",
              overflowX: "hidden !important",
              resize: "none !important",
              boxSizing: "border-box !important",
            },
            "& .MuiInputBase-input::-webkit-scrollbar": {
              width: "6px",
            },
            "& .MuiInputBase-input::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "3px",
            },
            "& .MuiInputBase-input::-webkit-scrollbar-thumb": {
              background: "#c1c1c1",
              borderRadius: "3px",
            },
            "& .MuiInputBase-input::-webkit-scrollbar-thumb:hover": {
              background: "#a1a1a1",
            },
          }}
          value={inputValue}
          multiline
          onChange={(e) => setInputValue(e.target.value)}
          InputProps={{
            style: {
              height: pxToRem(218),
              maxHeight: pxToRem(218),
              overflow: "hidden",
              alignItems: "flex-start",
            },
          }}
          inputProps={{
            style: {
              resize: "none",
              height: pxToRem(194),
              maxHeight: pxToRem(194),
              overflowY: "auto",
              overflowX: "hidden",
            },
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: pxToRem(40),
        }}
      >
        <CustomButton
          onClick={handleAddNote}
          sx={{
            width: pxToRem(467),
            height: pxToRem(64),
            fontSize: pxToRem(24),
            backgroundColor: Colors.PRIMARY,
            color: Colors.WHITE,
            borderRadius: pxToRem(5),
            whiteSpace: "nowrap",
          }}
          disabled={!inputValue}
        >
          Add Note
        </CustomButton>
      </Box>
    </CustomModal>
  );
};
